import { CreateUserDto } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllUserResponseModel extends GlobalResponseObject {
    data?: CreateUserDto[];
}
